import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/app-config.service';
@Injectable({
  providedIn: 'root'
})
export class ReadConfigService {

  constructor(private appConfig: AppConfigService) { }

  config: any = this.appConfig.getConfig();

  // common
  getcryptoKey(): string {
    return this.config !== undefined ? this.config.CryptoKey : '';
  }

  getCurrentStage() {
    return this.config ? this.config.CurrentStage : 4;
  }

  getApiUrl(): string {
    return this.config ? this.config.API_URL : '';
  }

  getInsightKey(): string {
    return this.config ? this.config.appInsights : '';
  }

  getApiTimeout(): number {
    return this.config ? this.config.ApiTimeout : 300;
  }

  getOutageScheduledDetails(): any {
    return this.appConfig.getScheduledMaintenance();
  }

  getOutageText() {
    return this.config.OutageText;
  }

  getMenuItems(): string[] {
    return this.config ? this.config.MenuItems : [];
  }

  getSubTasks() {
    return this.config ? this.config.SubTasks : {};
  }

  getIsEPOneReleaseDF() {
    return this.config.IsEPOneReleaseDF;
  }

  getDarkFeatureFlag(value: any) {
    return this.appConfig.getDarkKeyValue(value);
  }

  getContactUserTitle() {
    return this.config ? this.config.ContactUserTitle : 'Manager Users/Contacts';
  }

  getForbiddenText() {
    return this.config.ForbiddenText;
  }

  getServiceErrorText() {
    return this.config.ServiceError;
  }

  getOutageDFName() {
    return this.config.OutageDFName;
  }

  getLoginRedirectTime() {
    return this.config.LoginRedirectTime;
  }

  getGeneralErrorMessage() {
    return this.config ? this.config.GeneralErrorMessage : '';
  }

  getErrorHideAfter() {
    return this.config ? this.config.ErrorHideAfter : '';
  }

  getSuccessHideAfter() {
    return this.config ? this.config.SuccessHideAfter : '';
  }

  getEditModeOrgSelect() {
    return this.config ? this.config.EditModeOrgSelect : '';
  }

  getPaymentMethodInfo() {
    return this.config ? this.config.PaymentMethodInfo : '';
  }

  getContactUpdateText(value: string) {
    return this.config ? this.config.ContactUpdate[value] : '';
  }

  getMobileScrollMessage() {
    return this.config.MobileScrollMessage;
  }

  getSecuMessagesText() {
    return this.config.SecureMessages;
  }

  // payments bank info
  getBankingInfoText() {
    return this.config ? this.config.BankingInfoText : '';
  }

  getSPNews() {
    return this.config ? this.config.SPNews : '';
  }

  // uploads
  getMaxRecordCount() {
    return this.config ? this.config.Max_Record_Count : 0;
  }

  getMaxAmount() {
    return this.config ? this.config.Max_Amount : 0;
  }

  // Payroll
  getPayrollUploadFile() {
    return this.config ? this.config.PayrollFileUpload : '';
  }

  // User Management
  getUserManagement() {
    return this.config ? this.config.UserManagement : '';
  }

  // Uploads
  getUploadFile() {
    return this.config ? this.config.UploadFile : '';
  }

  getMemberDocFileUpload() {
    return this.config ? this.config.MemberDocFileUpload : '';
  }

  getTerminateText() {
    return this.config ? this.config.TerniamteEmployee : '';
  }

  //Cutoff Notices
  getCutoffNoticesText() {
    return this.config ? this.config.CutoffNotices : '';
  }

  // Enrollments
  getStepperLabels() {
    return this.config.Steps;
  }

  getEnrollmentMemberText() {
    return this.config ? this.config.EnrollmentMember : '';
  }

  // Adjustment v2
  getAdjustmentv2Text() {
    return this.config ? this.config.AdjustmentV2FileUpload : '';
  }

  // Adjustment
  getAdjustmentFileUpload() {
    return this.config ? this.config.AdjustmentFileUpload : '';
  }

  // pay schedules
  getPayScheduleText() {
    return this.config ? this.config.PaySchedule : '';
  }

  // documents
  getDocumentErrorMessage() {
    return this.config ? this.config.DocumentErrorMessage : '';
  }

  getDocumentMinSize() {
    return this.config ? this.config.ResponseSize : 100;
  }

  // invoice
  getInvoiceText() {
    return this.config ? this.config.Invoice : '';
  }

  // Help
  getHelpText() {
    return this.config ? this.config.HelpContant : {};
  }
}
